import React from 'react';
import anu_logo from '../../Assets/anuvadini_logo.png';
import mlj from '../../Assets/logo.png';
import moe_logo from '../../Assets/moe_logo.png';
import './Header.css';
import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from "react";
// import JasonFile from "../../Pages/formLangfields.json";

function useHeader({ isAdminPage, langCodeDrop }) {
	const navigate = useNavigate();
	const [isLogin, setIsLogin] = useState(false);
	const [langCode, setLangCode] = useState();

	useEffect(() => {
		let isLogin = localStorage.getItem("isLogin");
		let selectedLang = localStorage.getItem("selectedLang");
		setIsLogin(isLogin);
		setLangCode(selectedLang);
	}, []);

	useEffect(() => {
		if (langCodeDrop) {
			setLangCode(langCodeDrop)
		}
	}, [langCodeDrop])

	// const handleLogout = () => {
	// 	localStorage.setItem("isLogin", false);
	// 	localStorage.removeItem("token");
	// 	navigate("/mkb100");
	// 	navigate(0);
	// };

	// const handleLogin = () => {
	// 	navigate('/mkb100/login');
	// 	navigate(0);
	// };

	// const handleAdminButton = () => {
	// 	navigate('/mkb100/add-query');
	// 	navigate(0);
	// }

	return (
		<>
			<div className="containerh">
				<header className="header">
					<div className="common">
						<div className="wrapper">
							<Link to="https://anuvadini.aicte-india.org/">
								<img className="image" src={anu_logo} alt='' width="210px" />
							</Link>
						</div>
						<div className="wrapper">
							<img className="image2" src={mlj} alt='' width="60px" />
						</div>
						<div className="wrapper">
							<img className="image3" src={moe_logo} alt='' width="120px" />
						</div>
					</div>

					<div className='d-flex justify-content-end buttonmargin'>
						<button className="homebtn h-auto w-auto" onClick={() => { navigate('/mkb100') }}>Home</button>
					</div>

					{/* {langCode ? <>
						{isLogin == 'true' ? <>
						<div className='d-flex justify-content-end buttonmargin'>
							{isAdminPage?<></>:
								<div className="wrapper">
									<button className="button w-auto" onClick={() => handleAdminButton()} >
										<b>{JasonFile[25][langCode]}</b>
									</button>
								</div>
							}
							<div className="wrapper">
								<button className="button w-auto" onClick={() => handleLogout()} >
									<b>{JasonFile[23][langCode]}</b>
								</button>
							</div>
							</div>
						</> : <>
							<div className="wrapper">
								<button className="button w-auto" onClick={() => handleLogin()}>
									<b>{JasonFile[22][langCode]}</b>
								</button>
							</div>
						</>}
					</>:<></>} */}
				</header>
			</div>
		</>
	)
}

export default useHeader;